module.exports = __webpack_public_path__ + "img/icon-new-pe.23aa14a1.svg";